/**
 * Fields whose value is typed verbatim (emails, logins): no iOS
 * autocapitalisation, autocorrection or spellcheck — this also hides the iOS
 * QuickType suggestion bar above the keyboard.
 */
export const VERBATIM_INPUT_PROPS = {
  autoCorrect: 'off',
  autoCapitalize: 'off',
  spellCheck: false,
} as const;

/**
 * Search fields: iOS word suggestions (the QuickType bar) and autocorrection
 * stay on, but no autocapitalisation or spellcheck underline.
 */
export const SEARCH_INPUT_PROPS = {
  autoCorrect: 'on',
  autoCapitalize: 'off',
  spellCheck: false,
} as const;
